import {useMutation} from "@tanstack/react-query";
import {suspendUserManagementUserMutationOptions} from "./suspend-user-management-user.mutation-options";

export function useSuspendUserManagementUser() {
  return useMutation(suspendUserManagementUserMutationOptions());
}
